module.exports = {
	methods: {
		addIconsConf: function(excludes = []){
			var allIcons = this.$root.icons;
			var someIcons = {};

			for (var prop in allIcons) {
				if (excludes.indexOf(prop) === -1){
					someIcons[prop] = allIcons[prop];
				}
			}
			// console.log(someIcons);
			return someIcons;
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/addIconsConf.js